import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomerFeedbackEntryMutationVariables = Types.Exact<{
  grade: Types.Scalars['Int']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
  urlSlug: Types.Scalars['String']['input'];
}>;


export type CreateCustomerFeedbackEntryMutation = { __typename?: 'RootMutationType', createCustomerFeedbackEntry: { __typename?: 'CreateCustomerFeedbackEntryResult', result?: { __typename?: 'CustomerFeedbackEntry', id: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, fields?: Array<string> | null }> } };


export const CreateCustomerFeedbackEntryDocument = gql`
    mutation CreateCustomerFeedbackEntry($grade: Int!, $comment: String, $urlSlug: String!) {
  createCustomerFeedbackEntry(
    input: {grade: $grade, comment: $comment, urlSlug: $urlSlug}
  ) {
    result {
      id
    }
    errors {
      message
      fields
    }
  }
}
    `;
export type CreateCustomerFeedbackEntryMutationFn = Apollo.MutationFunction<CreateCustomerFeedbackEntryMutation, CreateCustomerFeedbackEntryMutationVariables>;

/**
 * __useCreateCustomerFeedbackEntryMutation__
 *
 * To run a mutation, you first call `useCreateCustomerFeedbackEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerFeedbackEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerFeedbackEntryMutation, { data, loading, error }] = useCreateCustomerFeedbackEntryMutation({
 *   variables: {
 *      grade: // value for 'grade'
 *      comment: // value for 'comment'
 *      urlSlug: // value for 'urlSlug'
 *   },
 * });
 */
export function useCreateCustomerFeedbackEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerFeedbackEntryMutation, CreateCustomerFeedbackEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerFeedbackEntryMutation, CreateCustomerFeedbackEntryMutationVariables>(CreateCustomerFeedbackEntryDocument, options);
      }
export type CreateCustomerFeedbackEntryMutationHookResult = ReturnType<typeof useCreateCustomerFeedbackEntryMutation>;
export type CreateCustomerFeedbackEntryMutationResult = Apollo.MutationResult<CreateCustomerFeedbackEntryMutation>;
export type CreateCustomerFeedbackEntryMutationOptions = Apollo.BaseMutationOptions<CreateCustomerFeedbackEntryMutation, CreateCustomerFeedbackEntryMutationVariables>;